import React from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';

const DEP_TYPES = [
  { value: 'CONJOINT', label: 'Conjoint' },
  { value: 'CONJOINTE', label: 'Conjointe' },
  { value: 'ENFANT', label: 'Enfant' }
];

const SEX_OPTIONS = [
  { value: '', label: '—' },
  { value: 'M', label: 'M' },
  { value: 'F', label: 'F' }
];

export default function DependentsFieldArray({ value, onChange, errors = {} }) {
  const dependents = Array.isArray(value) ? value : [];

  const updateAt = (index, patch) => {
    const next = dependents.map((item, i) => {
      if (i !== index) return item;
      const merged = { ...item, ...patch };
      if (merged.type === 'CONJOINT') merged.sexe = 'M';
      if (merged.type === 'CONJOINTE') merged.sexe = 'F';
      return merged;
    });
    onChange(next);
  };

  const addLine = () => {
    onChange([
      ...dependents,
      { type: 'ENFANT', nom: '', prenom: '', sexe: '', date_naissance: '' }
    ]);
  };

  const removeLine = (index) => {
    onChange(dependents.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="small text-muted">Lignes : {dependents.length}</span>
        <Button variant="outline-primary" size="sm" onClick={addLine}>
          + Ajouter un ayant droit
        </Button>
      </div>

      {dependents.length === 0 ? (
        <div className="recv-modal-empty-inline">
          Aucun ayant droit pour l&apos;instant — optionnel.
        </div>
      ) : (
        <div className="d-grid gap-3">
          {dependents.map((dep, index) => (
            <Card key={`dep-${index}`} className="recv-modal-dep-card border-0">
              <Card.Body className="p-3">
                <Row className="g-2">
                  <Col md={3} xs={12}>
                    <Form.Label className="small">Type</Form.Label>
                    <Form.Select
                      size="sm"
                      value={dep.type || 'ENFANT'}
                      onChange={(e) => updateAt(index, { type: e.target.value })}
                    >
                      {DEP_TYPES.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md={3} xs={12}>
                    <Form.Label className="small">Nom</Form.Label>
                    <Form.Control
                      size="sm"
                      value={dep.nom || ''}
                      onChange={(e) => updateAt(index, { nom: e.target.value })}
                      isInvalid={!!errors[`dependents.${index}.nom`]}
                    />
                  </Col>
                  <Col md={3} xs={12}>
                    <Form.Label className="small">Prénom</Form.Label>
                    <Form.Control
                      size="sm"
                      value={dep.prenom || ''}
                      onChange={(e) => updateAt(index, { prenom: e.target.value })}
                      isInvalid={!!errors[`dependents.${index}.prenom`]}
                    />
                  </Col>
                  <Col md={2} xs={8}>
                    <Form.Label className="small">Sexe</Form.Label>
                    <Form.Select
                      size="sm"
                      value={dep.sexe || ''}
                      onChange={(e) => updateAt(index, { sexe: e.target.value })}
                      disabled={dep.type === 'CONJOINT' || dep.type === 'CONJOINTE'}
                    >
                      {SEX_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md={1} xs={4} className="d-flex align-items-end">
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="w-100"
                      onClick={() => removeLine(index)}
                    >
                      X
                    </Button>
                  </Col>
                  <Col md={4} xs={12}>
                    <Form.Label className="small">Date naissance</Form.Label>
                    <Form.Control
                      size="sm"
                      type="date"
                      value={dep.date_naissance || ''}
                      onChange={(e) => updateAt(index, { date_naissance: e.target.value })}
                    />
                  </Col>
                  <Col md={8} xs={12} className="d-flex align-items-end">
                    <div className="small text-muted">
                      Le matricule est généré automatiquement. Type conjoint/conjointe impose
                      automatiquement le sexe (M/F).
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}

